import { Directive, HostBinding, Input, inject } from '@angular/core';
import { Pwa } from './pwa.service';

/**
 * This allows to hide certain UI elements in PWA installed mode, e.g. app
 * store badges for instance (since, well, you're already inside an app -_-).
 */
@Directive({ standalone: false, selector: `[flPwaHideInstalled]` })
export class PwaHideInstalledDirective {
  private pwa = inject(Pwa);

  @HostBinding('attr.data-pwa-hide-installed')
  hideInstalled: boolean;

  @Input() set flPwaHideInstalled(hide: boolean) {
    this.hideInstalled = hide && this.pwa.isInstalled();
  }
}
